export const dashboardHubTour = {
  key: "dashboardHub",
  version: 1,
  getSteps: (t) => [
    {
      target: '[data-tour="dash-topmenu"]',
      content: t("Tour_Dashboard_TopMenu"),
      placement: "bottom",
      disableBeacon: true,
    },
    {
      target: '[data-tour="dash-hero-banner"]',
      content: t("Tour_Dashboard_Hero"),
      placement: "bottom",
    },
    {
      target: '[data-tour="dash-hub-boards"]',
      content: t("Tour_Dashboard_HubCards"),
      placement: "top",
      disableAutoPlacement: true,
    },
    {
      target: '[data-tour="dash-hub-coach"]',
      content: t("Tour_Dashboard_Coach"),
      placement: "top",
    },
    {
      target: '[data-tour="dash-hub-chats"]',
      content: t("Tour_Dashboard_Chats"),
      placement: "top",
    },
    {
      target: '[data-tour="dash-hub-projectoverview"]',
      content: t("Tour_Dashboard_ProjectOverview"),
      placement: "top",
    },
    {
      target: '[data-tour="dash-hub-aistudio"]',
      content: t("Tour_Dashboard_AIStudio"),
      placement: "top",
    },
    {
      target: '[data-tour="dash-hub-meetings"]',
      content: t("Tour_Dashboard_Meetings"),
      placement: "top",
    },
    {
      target: '[data-tour="dash-hub-tools"]',
      content: t("Tour_Dashboard_Tools"),
      placement: "top",
    },
    {
      target: '[data-tour="dash-hub-feed"]',
      content: t("Tour_Dashboard_Feed"),
      placement: "top",
    },
    {
      target: '[data-tour="dash-sidebar"]',
      content: t("Tour_Dashboard_Sidebar"),
      placement: "right",
    },
    {
      target: '[data-tour="dash-notifications"]',
      content: t("Tour_Dashboard_Notifications"),
      placement: "bottom",
    },
    {
      target: '[data-tour="dash-settings"]',
      content: t("Tour_Dashboard_Settings"),
      placement: "bottom",
    },
    {
      target: '[data-tour="dash-profile"]',
      content: t("Tour_Dashboard_Profile"),
      placement: "bottom",
    },
  ],
};